import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import { isMobile } from '../../utilities/helpers';
import LastSearch from '../wizardDesktop/LastSearch';
import { getWizardV2State } from './wizardService';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import { t } from '../../utilities/translator';

const WizardSkip = ({
  loading,
  filtersReady
}) => {
  // Mobile Wizard skip screen (on second visit)
  const { topLogo } = getWizardV2State();
  const [userName, setUserName] = useState('');
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);

  useBodyScrollLock({ condition: (loading || loading2), mobileOnly: true });

  useEffect(() => {
    let timeout = null;
    if (isMobile()) {
      const hfUser = JSON.parse(localStorage.getItem('hf_user'));
      if (hfUser && hfUser?.user?.firstName) {
        setUserName(hfUser?.user?.firstName);
      }
      timeout = setTimeout(() => {
        setLoading2(false);
      }, 4000);
    }
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    let timeout = null;
    if (!loading && !loading2) {
      timeout = setTimeout(() => {
        setLoading3(false);
      }, 500);
    }
    return () => clearTimeout(timeout);
  }, [loading, loading2]);

  if (!loading3) {
    return '';
  }

  return (
    <div className={cn("wizard-skip-screen flex flex-col gap-10", { 'ws-hide': (!loading && !loading2) })}>
      <div className="ws-logo flex justify-center">
        <img src={topLogo} alt="Logo" />
      </div>
      <div className="ws-main flex flex-col gap-5 justify-center items-center">
        <div className="ws-loader"><div className="ripple" /></div>
        <div className="ws-txt flex flex-col gap-2">
          <b>{userName ? t('onboarding.welcomeBackName', { name: userName }) : t('onboarding.welcomeBackStranger')}</b>
          <span>{t('onboarding.loadingYourLastFeed')}</span>
        </div>
      </div>
      <div className="ws-last-search">
        <LastSearch wizardSkip showWizardModal={false} filtersReady={filtersReady} />
      </div>
    </div>
  )
}

export default WizardSkip;
